module.exports = __webpack_public_path__ + "startpage-746fed5a/app-store-badge-en-80d7a116b6ee11e2c2c5372b33c0a145.svg";